// // src/App.js

// import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
// import Login from "./pages/Login";
// import Signup from "./pages/Signup";
// import Dashboard from "./pages/Dashboard";

// export default function App() {
//   return (
//     <Router>
//       <div className="App">
//         <nav style={{ margin: 10 }}>
//           <Link to="/login" style={{ marginRight: 10 }}>
//             Login
//           </Link>
//           <Link to="/signup">
//             Signup
//           </Link>
//         </nav>

//         <Routes>
//           <Route path="/login" element={<Login />} />
//           <Route path="/signup" element={<Signup />} />
//           <Route path="/dashboard" element={<Dashboard />} />
//           <Route path="/" element={<h2>Welcome to Firebase Auth Demo</h2>} />
//         </Routes>
//       </div>
//     </Router>
//   );
// }


///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


// src/App.js
// import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
// import Login from "./pages/Login";
// import Signup from "./pages/Signup";
// import Dashboard from "./pages/Dashboard";
// import { Navigate, Outlet } from "react-router-dom";
// import { getAuth } from "firebase/auth";


// function PrivateRoute() {
//   const auth = getAuth();
//   return auth.currentUser
//     ? <Outlet />
//     : <Navigate to="/login" replace />;
// }

// export default function App() {


//   return (

//     <Router>
//       <div className="bg-red-500 text-white p-4">
//         🚀 SlickAPI is working!
//       </div>
//       <nav className="bg-white shadow mb-6">
//         <div className="max-w-4xl mx-auto px-4 py-3 flex space-x-4">
//           <Link to="/login" className="text-gray-600 hover:text-gray-900">
//             Login
//           </Link>
//           <Link to="/signup" className="text-gray-600 hover:text-gray-900">
//             Signup
//           </Link>
//           <Link to="/dashboard" className="text-gray-600 hover:text-gray-900">
//             Dashboard
//           </Link>
//         </div>
//       </nav>
//       <Routes>
//         <Route path="/login" element={<Login />} />
//         <Route path="/signup" element={<Signup />} />
//         {/* <Route path="/dashboard" element={<Dashboard />} /> */}
//         <Route element={<PrivateRoute />}>
//           <Route path="/dashboard" element={<Dashboard />} />
//         </Route>
//         <Route path="/" element={<h2 className="text-center mt-6">Welcome to Firebase Auth Demo</h2>} />
//       </Routes>
//     </Router>
//   );
// }

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


// src/App.js
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useNavigate,
} from "react-router-dom";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import LandingPage from "./pages/LandingPage";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Pricing from "./pages/Pricing";

function Navbar() {
  const auth = getAuth();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  // listen for auth state changes
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setUser(u));
    return unsub;
  }, [auth]);

  const handleSignOut = async () => {
    await signOut(auth);
    navigate("/login");
  };


  return (
    <nav className="bg-red-500 text-white p-4 flex items-center">
      {/* show Login & Signup only when NOT signed in */}
      {!user && (
        <>
          <Link to="/login" className="mr-4 hover:text-red-200">
            Login
          </Link>
          <Link to="/signup" className="mr-4 hover:text-red-200">
            Signup
          </Link>
        </>
      )}

      <div className="absolute left-1/2 transform -translate-x-1/2">
        <h1 className="text-2xl font-extrabold underline bg-clip-text 
               bg-gradient-to-r from-green-400 via-white-500 to-blue-600 
               bg-[length:200%_200%] animate-gradient">
          SLICKAPI
        </h1>
      </div>

      {/* show Dashboard & Sign Out only when signed in */}
      {user && (
        <>
          <Link to="/dashboard" className="mr-4 hover:text-red-200">
            Dashboard
          </Link>
          <button
            onClick={handleSignOut}
            className="ml-auto px-3 py-1 text-white hover:text-red-200"
          >
            Sign Out
          </button>
        </>
      )}
    </nav>
  );
}

export default function App() {
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route
          path="/"
        // element={<h2 className="text-center mt-6">Welcome to Firebase Auth Demo</h2>}
        />
      </Routes>
    </Router>
  );
}